module.exports = __webpack_public_path__ + "static/media/upload-1.39eb6b96.svg";